// Every entry ties to a real seeded CA receipt (S-R1/S-R2) so the workflow
// resolves against real jobs/positions instead of fictional companies.
export interface DemoEmail {
  id: string;
  from: string;
  fromEmail: string;
  to: string;
  subject: string;
  date: string;
  body: string;
  companyName: string;
  ticker: string;
  jobNumber: string;
  unread: boolean;
}

export const DEMO_EMAILS: DemoEmail[] = [
  {
    id: 'email-001',
    from: 'Sarah Smith',
    fromEmail: 'sarah.smith@northpoint.com',
    to: 'ops@northpoint.com',
    subject: 'Office Properties Income Trust tender — which of my clients can participate?',
    date: 'Today, 8:42 AM',
    body: `Hi team — saw the Office Properties Income Trust tender announced overnight (job #3060101 / scan S-R1). I have 18 client accounts holding OPI and need to respond to clients by EOD. Which accounts are eligible, what are the tax implications, and is anyone close to the early-tender deadline?\n\nThanks — Sarah`,
    companyName: 'Office Properties Income Trust',
    ticker: 'OPI',
    jobNumber: '3060101',
    unread: true,
  },
  {
    id: 'email-002',
    from: 'James Chen',
    fromEmail: 'j.chen@harbormgmt.com',
    to: 'ops@northpoint.com',
    subject: 'NXG Next Gen Infrastructure Income Fund — client election deadline today',
    date: 'Today, 7:18 AM',
    body: `Team — the NXG Next Gen Infrastructure Income Fund election deadline (job #3060102 / scan S-R2) is today at 5pm ET. I have 6 accounts holding NXG and need to know which ones haven't submitted elections. Can you pull positions and check election status?\n\nUrgent — James`,
    companyName: 'NXG Next Gen Infrastructure Income Fund',
    ticker: 'NXG',
    jobNumber: '3060102',
    unread: true,
  },
];
